
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salt",
      function () {
        return require("private-next-pages/salt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salt"])
      });
    }
  